<template>
  <div class="imageupload">
    <div ref="dropTarget" class='introduction'>
      <div class="introduction__title">
        <h2>Upload an Image</h2>

        <table class="input-table">
          <tr>
            <td class="input-type">Paste</td>
            <td class="input-method">{{ platformModifierKey() }}+V</td>
          </tr>
          <tr>
            <td class="input-type">Drag</td>
            <td class="input-method">
              <svg xmlns="http://www.w3.org/2000/svg" class="input-icon" x="0px" y="0px" viewBox="300 200 500 700" xml:space="preserve">
  <path d="M539,
203.646c-117.475,
0-213,
95.572-213,
213.047v246.613c0,
117.475,
95.525,
213.047,
213,
213.047s213-95.572,
213-213.047  V416.693C752,
299.219,
656.475,
203.646,
539,
203.646z M730,
663.307c0,
105.388-85.613,
191.126-191,
191.126s-191-85.738-191-191.126V533  h382V663.307z M730,
511H549V225.846c101,
5.357,
181,
88.908,
181,
190.848V511z"/>
              </svg>
            </td>
          </tr>
          <tr>
            <td class="input-type">Choose</td>
            <td class="input-method">
              <button class='button' v-on:click='selectImage'>Select Image</button>
            </td>
          </tr>
          <tr>
            <td class="input-type">Demo</td>
            <td class="input-method">
              <button class='button js-use-sample' v-on:click='useSample'>Use Sample</button>
            </td>
          </tr>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
import imgsample from '../assets/cat.json';
import selectController from '../fileLoaders/select';
import dragController from '../fileLoaders/drag';
import pasteController from '../fileLoaders/paste';
import imageController from '../fileLoaders/image';

const dropTarget = null;

export default {
  name: 'ImageUpload',

  data() {
    return {
      platformModifierKey() {
        const isMac = navigator.platform.indexOf('Mac') > -1;
        return isMac ? 'CMD' : 'CTRL';
      },

    };
  },

  methods: {
    async useSample() {
      const image = await imageController.convertToImageElement(imgsample.src, 'base64');
      this.$store.dispatch('setImageElement', image);
    },

    selectImage() {
      selectController.selectImage();
    },

  },

  mounted() {
    this.$store.dispatch('reset');
    pasteController.init();
    dragController.init(this.$refs.dropTarget);

    this.$store.subscribe(({ type }) => {
      if (type === 'setImageElement') {
        this.$router.push('edit');
      }
    });
  },

  destroyed() {
    pasteController.destroy();
    dragController.destroy(dropTarget);
  },

};
</script>

<style scoped lang='scss'>
  @import "../styles/variables";

  .imageupload {
    height: 100%;
  }

  .introduction {
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    &.is-drag {
      background-color: darkseagreen;
    }

    .introduction__title {
      margin: auto;
    }
  }

  .button {
    width: 100%;
  }

  .input-table {
    margin: auto;
    text-align: left;
    border-spacing: 0 $spacing;
  }

  .input-type {
    padding-right: $spacing;
  }

  .input-method {
    text-align: center;
  }

  .input-icon {
    height: 40px;
  }
</style>
